import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray } from '@angular/forms';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { PollService } from 'src/app/core/http/poll/poll.service';
import { Subscription, } from 'rxjs';
import { debounceTime, distinctUntilChanged  } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'poll-fields-widget',
  templateUrl: './poll-fields.component.html',
  styleUrls: ['./poll-fields.component.css']
})
export class PollFieldsComponent implements OnInit {
  @Input() parentId;
  @Input() pollFields;
  pollFieldItem = {
    name: 'null',
    schema: 'null'
  }
  selected= "string";

  showPopup=false;
  showMore=false;

  enableEdit=false;
  enableEditIndex = -1;
  enableEditIndexPrev = -1;
  pollFieldItemPrev = null;
  pollFieldItemPrevChanged = null;
  fieldForm: FormGroup;

  changeFieldSubscription: Subscription;
  constructor(private _fb: FormBuilder, private pollService: PollService) { }
  
  ngOnInit(): void {
    this.createDefaultField();
    this.pollFieldItem.schema = this.createSchemaByLastFormValue;
  }

  get createSchemaByLastFormValue() {
    return this.fieldForm.value.schema;
  }

  createDefaultField() {
    this.fieldForm = this._fb.group({
      schema: this._fb.group({
        title:[''],
        type: 'string',
        widget: this._fb.group({
          id: [this.selected]
        })
      })
    })
  }
  
  hideMore() {
    this.showPopup=false;
    this.showMore=false;
  }
  ShowMore() {
    this.showMore=true;
    this.showPopup=true;
  }
  ChangeShowDescription(event) {
    if (event==true) {
      (<FormGroup>this.fieldForm.get('schema')).addControl('description', new FormControl(''));
    } else {
      (<FormGroup>this.fieldForm.get('schema')).removeControl('description');
    }
  }
  ChangeRequired(event) {
    if (event==true) {
      (<FormGroup>this.fieldForm.get('schema')).addControl('required', new FormControl('required'));
    } else {
      (<FormGroup>this.fieldForm.get('schema')).removeControl('required');
    }
  }
  addRequired(field) {
    if (field.required) {
      (<FormGroup>this.fieldForm.get('schema')).addControl('required', new FormControl('required'));
    } else if (this.getRequired){
      (<FormGroup>this.fieldForm.get('schema')).removeControl('required');
    }
  }
  addDescription(field) {
    if (field.description) {
      (<FormGroup>this.fieldForm.get('schema')).addControl('description', new FormControl(field.description));
    } else if (this.getDescription){
      (<FormGroup>this.fieldForm.get('schema')).removeControl('description');
    }
  }
  addItems(field) {
    if (field.items && field.items.oneOf) {
      this.addCheckboxItem(field.items.oneOf);
    } else {
      this.ClearRadioSchemaValue();
    }
  }
  get getDescription():boolean {
    return this.fieldForm.get('schema').get('description')?true:false;
  }
  get getRequired():boolean {
    return this.fieldForm.get('schema').get('required')?true:false;
  }
  changeWidget(widget) {
    this.ClearType();
    this.ClearRadioSchemaValue();
    if (widget=='radio') {
      this.addRadioSchemaValue();
      this.addType('string');
    }
    if (widget=='string') {
      this.addType('string');
    }
    if (widget=='checkbox') {
      this.addRadioSchemaValue();
      this.addType('array');
    }
    if (widget=='textarea') {
      this.addType('string');
    }

  }
  addType(str) {
    (<FormGroup>this.fieldForm.get('schema')).addControl('type', new FormControl(str));
  }
  ClearType() {
    (<FormGroup>this.fieldForm.get('schema')).removeControl('type');
  }
  addRadioSchemaValue() {
    (<FormGroup>this.fieldForm.get('schema')).addControl('items',  this._fb.group({
      type: ['string'],
      widget: this._fb.group({
        id: 'string'
      }),
      oneOf: this._fb.array([])
    }));
  }
  addCheckboxSchemaValue() {
    (<FormGroup>this.fieldForm.get('schema')).addControl('items',  this._fb.group({
      type: ['string'],
      widget: this._fb.group({
        id: 'string'
      }),
      oneOf: this._fb.array([])
    }));
  }

  ClearRadioSchemaValue() {
    (<FormGroup>this.fieldForm.get('schema')).removeControl('items');
    this.fieldForm.updateValueAndValidity();
  }


  addCheckboxItem(items?){
    if(items) {
      for (let item of items) {
        this.FormOneOfData.push(this.addCheckboxGroupWithValue(item.d, item.e));
      }
    } else {
      var d;
      var e;
      var ControlArray=this.FormOneOfData.controls;
      var len = ControlArray.length;
      if (len>0) {
        var lastItem=(this.getMaxItemIndex(ControlArray) + 1).toString();
        e = "item" + lastItem;
        d="Вариант " + lastItem;
      } else {
        d="Вариант 1"
        e="item1";
      }
      this.FormOneOfData.push(this.addCheckboxGroupWithValue(d, e));
    }
  }


  addCheckboxGroupWithValue(d, e): FormGroup {
    return this._fb.group({
      d: [d],
      e: [e]
    })
  }

  get FormOneOfData() { 
    if( <FormArray>this.fieldForm.get('schema').get('items') ) return <FormArray>this.fieldForm.get('schema').get('items').get('oneOf'); 
  }

  deleteCheckboxItem(j) {
    this.FormOneOfData.removeAt(j);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.FormOneOfData.controls, event.previousIndex, event.currentIndex);
    moveItemInArray(this.FormOneOfData.value, event.previousIndex, event.currentIndex);
  }

  getMaxItemIndex(array) {
    var names=[];
    array.forEach(x => {
      names.push(Number(x.value.e.match(/(\d+)/)[0]));
    });
    return names.reduce((a, b)=>Math.max(a, b));
  }

  createFieldBody(schema, id?) {
    var body = {
      name: '',
      schema: schema
    };
    if (id) {
      body.name='field'+id;
    } else {
      body.name='field'
    }
    
    return body;
  }
  openEditForm(i, fieldData) {
    if (this.changeFieldSubscription) this.changeFieldSubscription.unsubscribe();
    if (this.enableEditIndexPrev >= 0) {
      if (this.pollFieldItemPrevChanged !== null) {
        this.pollFields[this.enableEditIndexPrev] = this.pollFieldItemPrevChanged;
        this.pollFieldItemPrevChanged = null;
      } else {
        this.pollFields[this.enableEditIndexPrev] = this.pollFieldItemPrev;
      }
    }
    this.enableEditIndexPrev = i;
    let field = fieldData.schema;
    this.enableEdit = true;
    this.enableEditIndex = i;
    this.fieldForm = this._fb.group({
      schema: this._fb.group({
        title:[field.title],
        widget: this._fb.group({
          id: [field.widget.id?field.widget.id:this.selected]
        })
      })
    });
    this.changeWidget(field.widget.id);
    this.addDescription(field);
    this.addRequired(field);
    this.addItems(field);
    this.changeFieldSubscription = this.fieldForm.valueChanges
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
    .subscribe(()=> {
      this.pollService.EditField(fieldData.id, this.createFieldBody(this.fieldForm.value.schema, fieldData.id))
      .subscribe((resp:any)=> {
        this.pollFieldItemPrevChanged = {
          id: resp.id,
          schema: resp.schema
        };
      }); 
    });
  }

  pushField(i) {
    let nextI = i+1;
    if (i !== -1) {
    this.pollFieldItemPrev = {
        id: this.pollFields[i].id,
        schema: this.fieldForm.value.schema
    };
    }
    this.pollService.AddField(this.parentId, this.pollFieldItem)
    .subscribe((resp:any) => {
      this.pollService.EditField(resp.id, this.createFieldBody(resp.schema, resp.id))
      .subscribe((res: any) => {
        let newField = {
          id:res.id,
          schema: res.schema
        }
        if ( nextI == 0 ) {
          this.pollFields=[];
          this.pollFields.push(newField);
          
        } else if (this.pollFields)
        {
          this.pollFields.splice(nextI, 0, newField)
        }
        this.openEditForm(nextI, this.pollFields[nextI]);
      })      
    });
    
    
  }
  copyField(i) {
    let nextI = i+1;
    if (this.enableEditIndexPrev >= 0) {
      this.pollFieldItemPrev = {
        id: this.pollFields[i].id,
        schema: this.fieldForm.value.schema
      }
    }
    this.pollFieldItem.schema = this.createSchemaByLastFormValue;
    this.pollService.AddField(this.parentId, this.pollFieldItem)
    .subscribe((res:any) => {
      this.pollFields.splice(nextI, 0, {
        id:res.id,
        schema: res.schema
      });
      this.openEditForm(nextI, this.pollFields[nextI]);
    });
  }
  deleteField(i, id) {
    this.pollService.DeleteField(id)
    .subscribe(()=> {
      this.pollFields.splice(i,1);
      this.enableEdit = false;
      this.enableEditIndex = -1;
      this.enableEditIndexPrev = -1;
      this.pollFieldItemPrev = null;
      this.pollFieldItemPrevChanged = null;
    });
  }

  ngOnDestroy() {
    if(this.changeFieldSubscription) this.changeFieldSubscription.unsubscribe();
  }
}
